import { Component, OnInit } from '@angular/core';
import {environment} from '../../../../environments/environment';

@Component({
  selector: 'app-picking-group-in-separation-header',
  templateUrl: './picking-group-in-separation-header.component.html',
  styleUrls: ['./picking-group-in-separation-header.component.scss']
})
export class PickingGroupInSeparationHeaderComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

  isDev(): boolean {
    return environment.name === 'dev';
  }
}
